import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  // Only auto-attach the producer token when the caller has NOT already set an
  // Authorization header. The customer portal (CustomerAuthService) attaches its
  // own customer JWT via ApiService.*WithAuth; preserving that header keeps the
  // customer session fully isolated from the producer session even when both are
  // signed in in the same browser. Producer service calls all pass the producer
  // token explicitly, so their behaviour is unchanged.
  if (
    token &&
    shouldAddToken(request.url) &&
    !request.headers.has('Authorization')
  ) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(request);
};

function shouldAddToken(url: string): boolean {
  // Add token to all API requests except authentication endpoints. The
  // customer-auth endpoints (portal login/register) are public and must never
  // carry the producer token.
  return url.includes('/api/') &&
         !url.includes('/customer-auth/') &&
         !url.includes('/login') &&
         !url.includes('/forgot-password') &&
         !url.includes('/reset-password') &&
         !url.includes('/setup-password');
}
